import { createTheme } from '@mui/material';

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#0E1B4E',
      contrastText: '#fff',
    },
  },
});

export default customTheme;
